import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, token, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Loading...</div>; // or a proper <Loader />
  }
  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }


  return children;
};

export default PrivateRoute;
